// removed by extract-text-webpack-plugin
module.exports = {"base":"LackOfIndustrialResource_base--14kXC","description":"LackOfIndustrialResource_description--1JwOo","lack":"LackOfIndustrialResource_lack--1Qxy6"};


//////////////////
// WEBPACK FOOTER
// ./components/LackOfIndustrialResource/LackOfIndustrialResource.scss
// module id = 2099
// module chunks = 11